import { ComoReceber } from "./ComoReceber"
import React from "react"
import ReactDOM from "react-dom"
import { urlParam } from "@atos6/utils"
import "antd/dist/antd.css"

export function mount(el: HTMLElement) {
  const props = {
    orgId: urlParam("id", el.dataset.organizationId),
    authToken: urlParam("token", el.dataset.authToken),
    graphqlUrl: urlParam("url", el.dataset.graphqlUrl),
  }
  ReactDOM.render(React.createElement(ComoReceber, props), el)
}
